/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Feed_UrlInputs */

const cs_import_feed_url = /** @type {(inputs: Import_Feed_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL XML feedu`)
};

const en_import_feed_url = /** @type {(inputs: Import_Feed_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML feed URL`)
};

/**
* | output |
* | --- |
* | "XML feed URL" |
*
* @param {Import_Feed_UrlInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_feed_url = /** @type {((inputs?: Import_Feed_UrlInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Feed_UrlInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_feed_url(inputs)
	return cs_import_feed_url(inputs)
});